import React, { useEffect, useState } from 'react';
import axios from 'axios';
import api from '../../api';
import { Link } from 'react-router-dom';
import { FiCheckCircle, FiXCircle, FiSettings, FiPlus } from 'react-icons/fi';
import { toast, ToastContainer } from 'react-toastify'; // <== Ajouté ici
import 'react-toastify/dist/ReactToastify.css'; // <== Ajouté ici

const RoleTable = () => {
  const [roles, setRoles] = useState([]);
  const [etapes, setEtapes] = useState([]);

  const colors = {
    primary: '#2C3E50',
    secondary: '#34495E',
    accent: '#875A7B',
    light: '#ECF0F1',
    success: '#27AE60',
    danger: '#E74C3C',
    text: '#2C3E50',
    border: '#BDC3C7',
    accentHover: '#6d4961'
  };

  useEffect(() => {
    api.get('/parametrages/roles')
      .then(response => {
        const allRoles = response.data.roles;
        const allEtapes = new Set();

        allRoles.forEach(role => {
          role.etapes.forEach(etape => {
            allEtapes.add(JSON.stringify({ id: etape.id, nom: etape.nom }));
          });
        });

        setRoles(allRoles);
        setEtapes([...allEtapes].map(e => JSON.parse(e)));
      })
      .catch(error => {
        console.error('Erreur lors du chargement des rôles:', error);
        
        // Toast d'erreur
        toast.error('Erreur lors du chargement des rôles.');
      });
  }, []);

  return (
    <div className="p-8 min-h-screen ">
      <ToastContainer />

      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-2xl font-bold text-terrecuite-800 flex items-center">
            <FiSettings className="inline mr-3 text-terrecuite-600" size={24} />
            Gestion des Autorisations
          </h1>

          <Link to='/admin/RoleEtapesSelector'>
            <button
              className="flex items-center px-4 py-2 rounded-md shadow-sm transition-colors duration-200 bg-terrecuite-600 hover:bg-terrecuite-700 text-white font-medium"
            >
              <FiPlus className="mr-2" size={18} />
              UPDATE AUTORISATION
            </button>
          </Link>
        </div>

        <div className="bg-white rounded-lg shadow-sm overflow-hidden border border-terrecuite-200">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-terrecuite-600 text-white">
                  <th className="p-4 text-left font-medium">RÔLE</th>
                  {etapes.map(etape => (
                    <th key={etape.id} className="p-4 text-center font-medium">
                      {etape.nom.toUpperCase()}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {roles.map((role, index) => (
                  <tr key={role.id} className={index % 2 === 0 ? 'bg-white' : 'bg-terrecuite-50'}>
                    <td className="p-4 border-b border-terrecuite-100">
                      <span className="font-semibold text-terrecuite-900">
                        {role.nom}
                      </span>
                    </td>
                    {etapes.map(etape => {
                      const isAssigned = role.etapes.some(e => e.id === etape.id);
                      return (
                        <td key={etape.id} className="p-4 border-b border-terrecuite-100 text-center">
                          {isAssigned ? (
                            <FiCheckCircle size={20} className="mx-auto text-green-500" />
                          ) : (
                            <FiXCircle size={20} className="mx-auto text-red-500" />
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-6 text-sm text-right text-terrecuite-500">
          {roles.length} rôles configurés • {etapes.length} étapes disponibles
        </div>
      </div>
    </div>
  );
};

export default RoleTable;
